import { IconShare } from "@/assets/icons/geist/IconShare";
import { Button } from "@/components/flexkit/Button";
import { useResourcePermissions } from "@/hooks/use-resource-permissions";
import { useShareResource } from "@/hooks/use-share-resource";
import { useProject } from "@/queries/project-queries";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { type FC } from "react";

type ShareProjectButtonProps = {
    projectId: string;
};

export const ShareProjectButton: FC<ShareProjectButtonProps> = ({ projectId }) => {
    const { openShareDialog } = useShareResource();
    const { data: project } = useProject(projectId);
    const { hasPermission } = useResourcePermissions();

    const canShareProject = hasPermission(ResourceType.PROJECT, projectId, "project:grant");

    const handleShareClick = () => {
        if (project) {
            openShareDialog({
                resourceType: ResourceType.PROJECT,
                resourceId: project.id,
                resourceName: project.metadata?.name || "Untitled Project",
            });
        }
    };

    if (!canShareProject) {
        return null;
    }

    return (
        <Button
            variant="outline"
            onClick={handleShareClick}
            disabled={!project}
            data-testid="share-project-button"
            data-tracking-id="share-project-button"
            LeadingIcon={IconShare}
            size={"sm"}
        >
            Share
        </Button>
    );
};
